import { action, makeObservable, observable } from 'mobx';
import { FrequencyAndBalancing } from 'src/integration/types/FrequencyAndBalancing';

class FrequencyAndBalancingStore {
  @observable frequencyAndBalancing: FrequencyAndBalancing[] = [];
  @observable version: number = Date.now();

  @action setFrequencyAndBalancingData = (data: SimpleObject[]) => {
    this.frequencyAndBalancing = data as FrequencyAndBalancing[];
    this.version = Date.now();
  };

  constructor() {
    makeObservable(this);
  }
}

export default FrequencyAndBalancingStore;
